import React, { useEffect, useState } from 'react';
import VenueForm from './VenueForm';

function AddVenue() {
  const [form, setForm] = useState({
    venue_name: '',
    description: '',
    live_music_ind: false,
    dancefloor_ind: true,
    live_ind: true,
    music_ids: [],
    location_id: ''
  });
  const [musicOptions, setMusicOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchOptions = async () => {
      const musicRes = await fetch('/api/music', { headers: { 'Authorization': `Bearer ${token}` } });
      if (musicRes.ok) setMusicOptions(await musicRes.json());

      const locRes = await fetch('/api/locations', { headers: { 'Authorization': `Bearer ${token}` } });
      if (locRes.ok) setLocationOptions(await locRes.json());
    };
    fetchOptions();
  }, [token]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const res = await fetch('/api/venues', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(form)
    });

    if (res.ok) {
      alert('Venue added!');
      setForm({
        venue_name: '',
        description: '',
        live_music_ind: false,
        dancefloor_ind: true,
        live_ind: true,
        music_ids: [],
        location_id: ''
      });
    } else {
      const data = await res.json();
      alert(data.message || 'Error adding venue');
    }
    setIsSubmitting(false);
  };

  return (
    <VenueForm
      form={form}
      onChange={handleChange}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      musicOptions={musicOptions}
      locationOptions={locationOptions}
    />
  );
}

export default AddVenue;
